export default {
  getDetail: state => state.detail,
  getPaymentList: state => state.paymentList,
  getCondition: state => state.condition,
  getPageInfo: state => state.pageInfo
};
